import AddCardOutlined from '@mui/icons-material/AddCardOutlined';
import BadgeOutlined from '@mui/icons-material/BadgeOutlined';
import BarChartOutlined from '@mui/icons-material/BarChartOutlined';
import ChevronRightOutlined from '@mui/icons-material/ChevronRightOutlined';
import DeliveryDiningOutlined from '@mui/icons-material/DeliveryDiningOutlined';
import ElectricScooterOutlined from '@mui/icons-material/ElectricScooterOutlined';
import EmojiEventsOutlined from '@mui/icons-material/EmojiEventsOutlined';
import KeyboardDoubleArrowRightOutlined from '@mui/icons-material/KeyboardDoubleArrowRightOutlined';
import KeyboardReturnOutlined from '@mui/icons-material/KeyboardReturnOutlined';
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined';
import PermIdentityOutlined from '@mui/icons-material/PermIdentityOutlined';
import PersonOutlined from '@mui/icons-material/PersonOutlined';
import PersonPinCircleOutlined from '@mui/icons-material/PersonPinCircleOutlined';
import PersonPinOutlined from '@mui/icons-material/PersonPinOutlined';
import RocketLaunchOutlined from '@mui/icons-material/RocketLaunchOutlined';
import ShoppingBagOutlined from '@mui/icons-material/ShoppingBagOutlined';
import SourceOutlined from '@mui/icons-material/SourceOutlined';
import WarehouseOutlined from '@mui/icons-material/WarehouseOutlined';
/*  
  A map of the mui icons that are used in the app
  This is a temporary solution and will be removed once we move away from Oxygen hosting
  It's purpose is to keep the bundle size small by only including the icons that are used in the app rather than the entire mui icon library
  We can add more icons to this map as needed
*/
export const IconsMap = {
  KeyboardDoubleArrowRightOutlined: KeyboardDoubleArrowRightOutlined,
  ChevronRightOutlined: ChevronRightOutlined,
  PersonOutlined: PersonOutlined,
  WarehouseOutlined: WarehouseOutlined,
  PersonPinCircleOutlined: PersonPinCircleOutlined,
  ElectricScooterOutlined: ElectricScooterOutlined,
  BarChartOutlined: BarChartOutlined,
  RocketLaunchOutlined: RocketLaunchOutlined,
  AddCardOutlined: AddCardOutlined,
  ShoppingBagOutlined: ShoppingBagOutlined,
  EmojiEventsOutlined: EmojiEventsOutlined,
  PersonPinOutlined: PersonPinOutlined,
  DeliveryDiningOutlined: DeliveryDiningOutlined,
  PermIdentityOutlined: PermIdentityOutlined,
  BadgeOutlined: BadgeOutlined,
  SourceOutlined: SourceOutlined,
  LocalShippingOutlined: LocalShippingOutlined,
  KeyboardReturnOutlined: KeyboardReturnOutlined,
};
